<script>
import { gqlClient } from "@root/apollo/apollo-options";
import { searchStoreList } from "@root/graphql/Common.gql";
import { resRest } from "@root/lib/utils";

const DEFAULT_LABLE_KEY = "storeName";
const DEFAULT_VALUE_KEY = "storeCode";

// 是否请求过cacheOptions的标识
let cacheLoaded = false;
// 将 cacheOptions 提到更高的作用域以复用 减少不必要的请求
let cacheOptions = [];

export default {
  name: "GtNodePicker",
  data() {
    return {
      options: [],

      pickedOptions: [] // 包含了已选绑定值的 options
    };
  },
  render(h) {
    return h("gt-smart-select", {
      props: {
        options: this.options,
        clearable: true,
        filterable: true,
        remote: true,
        "label-key": DEFAULT_LABLE_KEY,
        "value-key": DEFAULT_VALUE_KEY,
        placeholder: this.$t("Basic.Select"),
        remoteMethod: this._remoteMethod.bind(this),
        ...this.$attrs,
        // 禁用多选
        multiple: false
      },
      on: {
        // 如果父组件中自定义了 focus 的监听函数
        // 以下自定义的 focus 监听函数会被覆盖
        focus: () => {
          // 如果有绑定值 但是此时的 options 为空数组
          // 需要将options重置为 暂存的 pickedOptions
          if (!this.options.length) {
            this.options = cacheOptions;
          }
        },

        // 传递
        ...this.$listeners
      }
    });
  },
  mounted() {
    // cacheOptions 若存在则直接使用 可避免一次接口请求
    if (cacheLoaded) {
      this.options = cacheOptions;
      return;
    }

    this.$nextTick(() => {
      this._remoteMethod();
    });
  },
  methods: {
    async _remoteMethod(query = "") {
      let dataList = [];

      try {
        const { data } = await gqlClient.query({
          query: searchStoreList,
          variables: {
            // searchStoreList 接口支持最大的pageSize为100
            pageInput: { pageNum: 1, pageSize: 100 },
            searchKey: query,
            condition: {
              queryStoreManager: false, // 性能考虑
              searchKeyConditions: [
                { key: "storeCode" },
                { key: "storeName" },
                { key: "externalCode" }
              ],
              sortConditions: [
                {
                  key: "storeName",
                  type: 0
                }
              ]
            }
          }
        });

        dataList = resRest(data);
      } catch (err) {
        console.error(err);
      }

      this.options = dataList;

      // 缓存数据
      if (!cacheLoaded) {
        cacheOptions = dataList;
        cacheLoaded = true;
      }
    },

    /*
     * getCurrentBind
     * - 暴露给外部的方法
     * - 用户获取当前绑定值对应的原数据对象
     */
    getCurrentBind() {
      const valueKey = this.$attrs["value-key"] || DEFAULT_VALUE_KEY;
      const labelKey = this.$attrs["label-key"] || DEFAULT_LABLE_KEY;
      const { value } = this.$attrs;
      const options = this.options;
      const target = options.find(item => item[valueKey] === value);

      return target || {};
    }
  }
};
</script>

<style lang="scss"></style>
